module.exports = __webpack_public_path__ + "img/close-icon.8ef35fa9.svg";